import { defineAgenda } from '@/shared/navigation/core';
import { listPageViewState } from '@/shared/navigation/react/listPageViewState';

/**
 * Agenda seznamu vozů (`Inventory / Vehicle inventory`) — kořenová agenda slicu Inventory.
 * Univerzální ListPage (engine `@/shared/ui/list-page`, šablona `vehicleListPage.tsx`); detail
 * otevírá výběrem řádku přes `openDetail`.
 */
export const vehicleListAgenda = defineAgenda({
  id: 'app.inventory.vehicles',
  path: 'app/inventory/vehicles',
  open: {},
  state: listPageViewState,
  title: 'Vozy',
  icon: 'bus',
});
